import { getOgUrl, t } from '../../../../../modules/utils'

import { NextPageContext } from 'next'
import CenterContainer from '../../../../../components/common/CenterContainer'
import NewSimpleContainer from '../../../../../components/common/NewSimpleContainer'
import NewBasicContainer from '../../../../../components/container/NewBasicContainer'
import UnsubscribeBody from '../../../../../components/subscription/UnsubscribeBody'
import { InitialProps } from '../../../../../model/Common/common.interface'
import { useCurrentUser } from '../../../../../modules/context/UserContext'
import { LOCALE_KO } from '../../../../../modules/i18n/config'
import { s_head } from '../../../../../modules/i18n/strings/auto/wording'

const Index = ({ navigation }: InitialProps) => {
  const { currentUser } = useCurrentUser()

  return (
    <NewBasicContainer landing>
      <NewSimpleContainer>
        <CenterContainer>
          <UnsubscribeBody currentUser={currentUser} />
        </CenterContainer>
      </NewSimpleContainer>
    </NewBasicContainer>
  )
}

Index.getInitialProps = async (context: NextPageContext) => {
  const { lang = LOCALE_KO } = context.query
  const navigation = context.query.email
  const ogData = {
    title: t(s_head.student.title, lang),
    desc: t(s_head.student.desc, lang),
    ogUrl: getOgUrl({ lang, context }),
  }
  return { navigation, ogData }
}

export default Index
